import { defineLoader, httpTaskToResponseTask } from '@core/router/loader';
import { z } from 'zod';
import { Auth } from '@modules/auth/model';
import { AuthService } from '@modules/auth/service';
import { defineRoute } from '@core/router';

const params = z.object({ token: Auth.Token });

const loader = defineLoader({
  params,
  handler: ({ params }) => httpTaskToResponseTask(AuthService.exchangeToken(params.token)),
  redirect: () => '/',
});

const loginWithTokenRoute = defineRoute({
  loader,
});

export default loginWithTokenRoute;
